const bulknicotinepouches = {
    id: 'bulknicotinepouches',
    publicSiteName: 'Bulk Nicotine Pouches',
    branch: process.env.NEXT_PUBLIC_SHOP_BRANCH,
    siteUrl: process.env.NEXT_PUBLIC_SITE_URL,
    googleVerification: process.env.NEXT_PUBLIC_GOOGLE_SITE_VERIFICATION,
    gaId: process.env.NEXT_PUBLIC_GA_ID,
    theme: {
        colors: {
            primary: '#1f9f40',
            secondary: '#01350e',
        },
        fonts: {
            body: 'var(--font-sans)',
            heading: 'var(--font-heading)',
        },
        radius: '4px',
        header: {
            layout: 'classic',
            dark: false,
            sticky: true,
            showSearch: true,
            showAccount: true,
            showWishlist: true,
            showAnnouncementBar: true,
            transparent: false,
        }
    },
    assets: {
        favicon: '/bulknicotinepouches/favicon.ico',
        logo: '/bulknicotinepouches/logo.png',
    },
    features: {
        rewards: true,
        subscriptions: true,
    },
}

export default bulknicotinepouches